mtl.alloy.factory['layout-header'] = (function($, app, util) {
	'use strict';

	/**
	 * Controller for the layout header element.
	 */
	return function(element, options) {

		var $element = $(element);

		// ---------------------------------------------------------


		/**
		 * Megamenu
         */

		// Show/hide megamenu
		var $category = $('.layout-header-nav__menu').find($('.category'));
		$($category).hoverIntent(function() {

			$(this).children('.layout-header-megamenu__list').toggleClass('hidden');

			if($(this).data('processed') == true)
				return true;

			var listItems = $(this).children().find('li');
			var megaMenu = $(this).find('.layout-header-megamenu');

			// Get the total number of list items
			var listCount = $(this).children().find('li:not(.dummySpacer, .header, .shopAll, .featured)').length;
			var listHeaderCount = 0;
			// Header items count double
			listItems.each(function() {
				if($(this).hasClass('header')) {
					listCount++;
					listHeaderCount++;
				}
			});

			// Calculate number of list items per column
			var listItemsPerColumnn = Math.round(listCount/3);

			// Current number of unordered lists
			var unorderedListCount = $(this).find('ul.layout-header-megamenu__sublist:not(.layout-header-megamenu__sublist__featured-product)').length;

			while(unorderedListCount < 3) {
				var ul = $('<ul></ul>').addClass('layout-header-megamenu__sublist empty');
				megaMenu.append(ul);
				unorderedListCount++;
			}

			// Move extra items to the following unordered list
			var unorderedLists = $(this).find('ul.layout-header-megamenu__sublist:not(.layout-header-megamenu__sublist__featured-product)');
			var listCounter = 0;

			unorderedLists.each(function() {
				if(listItemsPerColumnn > 9 && listHeaderCount > 1) {
					while($(this).find('li').length > listItemsPerColumnn) {
						// Remove the last list item and append to following unordered list
						var listItem = $(this).find('li:not(.shopAll)').last();
						listItem.detach();
						unorderedLists.eq(listCounter+1).removeClass('empty').prepend(listItem[0]);
					}
					listCounter++;
				}
			});

			// Remove dummy spacer list items if they end up first in an unordered list
			unorderedLists.each(function() {
				if($(this).find('li').first().hasClass('dummySpacer')) {
					$(this).find('.dummySpacer').remove();
				}
			});

			// Move header if it ends up as the last item in an unordered list
			unorderedLists.each(function() {
				var $currListIndex = $(this).index();
				var $last = $(this).find('li').last();
				if($last.hasClass('header')) {
					$last.detach();
					unorderedLists.eq($currListIndex+1).prepend($last[0]);
				}
			});

			//Move featured product to the end
			var $featuredProduct = $(this).find('ul.layout-header-megamenu__sublist__featured-product');
			$featuredProduct.detach();
			$(this).find('.layout-header-megamenu').append($featuredProduct);

			$(this).data('processed', true);

		});

		// Set height of mega menu to viewport height minus header
		var $megaMenu = $('.layout-header-megamenu');
		var $megaMenuMaxHeight = ($(window).height()) - ($('.layout-header').height());
		$megaMenu.css('max-height', $megaMenuMaxHeight);

		// Move mobile navigation toggle into search bar
		var $menuToggleButton = $('.id-menu-btn');
		var $navSearchBar = $('.layout-header-main__search');
		var $toggle = $menuToggleButton.detach();
		$toggle.insertAfter($navSearchBar);



		// ---------------------------------------------------------

		/**
		 * Hide the off-canvas menu.
		 */
		function hideOffCanvasMenu() {

			$(document.body).removeClass('ui-show-ocm');

		}


		/**
		 * Toggle off-canvas menu visibility.
		 */
		function toggleOffCanvasMenu() {

			$(document.body).toggleClass('ui-show-ocm');

		}

		function showImages() {

			var size = app.breakpoint.is('phone-s') ? 'small' : 'large';

			$('img').each(function(){
				var smallAttr = $(this).attr('data-smallimage');
				var largeAttr = $(this).attr('data-largeimage');

				if (typeof smallAttr !== typeof undefined && smallAttr !== false && size == 'small') {
					$(this).attr('src', smallAttr);
				} else if (typeof largeAttr !== typeof undefined && largeAttr !== false && size == 'large') {
					$(this).attr('src', largeAttr);
				}
			});

		}

		// Update the tablet overflow menu on resize and document.ready
		$(window).on('resize orientationchange', showImages);
		$(document).ready(showImages);


		// Hide the off-canvas menu when leaving phone breakpoints
		app.breakpoint.when('phone-l phone-s', null, hideOffCanvasMenu);


		// Priority-menu variables
		var $tabletMenu;
		// var tabletMenuItemSlice = -1;
		var isTabletMenuVisible = false;


		/**
		 * Show the tablet overflow menu.
		 */
		function showTabletMenu() {

			if (isTabletMenuVisible || app.breakpoint.not('tablet-l tablet-s')) {
				return;
			}

			if ($tabletMenu == null) {
				var $container = $element.find('.id-menu-container');
				$tabletMenu = $container
					.find('ul')
					.first()
					.clone()
					.addClass('tablet-menu')
					.addClass('is-collapsed')
					.insertAfter($container)
				;
			}

			var $items = $tabletMenu.children();
			$items.show();

			$tabletMenu
				.stop(true, true)
				.queueAddClass('is-visible')
				.delay(25)
				.queueRemoveClass('is-collapsed')
			;

			$element.addClass('ui-show-tablet-menu');

			isTabletMenuVisible = true;

		}


		/**
		 * Hide the tablet overflow menu.
		 */
		function hideTabletMenu() {

			if ($tabletMenu == null || !isTabletMenuVisible) {
				return;
			}

			$tabletMenu
				.stop(true, true)
				.queueAddClass('is-collapsed')
				.delay(400)
				.queueRemoveClass('is-visible')
			;

			$element.removeClass('ui-show-tablet-menu');

			isTabletMenuVisible = false;

		}


		/**
		 * Toggle the visibility of the tablet overflow menu.
		 */
		function toggleTabletMenu() {

			if (isTabletMenuVisible) {
				hideTabletMenu();
			}
			else {
				showTabletMenu();
			}

		}


		/**
		 * Update the content of the tablet overflow menu.
		 */
		function updateTabletMenu() {

			if (app.breakpoint.not('tablet-l tablet-s')) {
				return;
			}

			var $items = $element.find('.id-menu-container li');

			var firstTop = $items[0].offsetTop;

			for (var i = 1, ix = $items.length; i < ix; i++) {
				if ($items[i].offsetTop > firstTop) {
					break;
				}
			}

			$element.find('.id-menu-btn').toggleClass('has-tablet-menu', i < ix);

		}


		// Listen for click events on the menu button
		$element.on('click', '.id-menu-btn', function() {

			if (app.breakpoint.is('phone-l phone-s')) {
				toggleOffCanvasMenu();
			}

			else if (app.breakpoint.is('tablet-l tablet-s')) {
				toggleTabletMenu();
			}

		});


		// Update the tablet overflow menu on resize and document.ready
		$(window).on('resize orientationchange', util.debounce(updateTabletMenu, 200));
		$(document).ready(updateTabletMenu);

		// Hide the tablet overflow menu when leaving tablet breakpoints
		app.breakpoint.when('tablet-l tablet-s', null, hideTabletMenu);


		// ---------------------------------------------------------


		// Scroll-top variables
		var scrollPositionWas = 0;


		/**
		 * Update the scroll-top status.
		 */
		function updateScrollTop() {

			var scrollPosition = $(window).scrollTop() | 0;

			var diff = (scrollPosition - scrollPositionWas) | 0;
			if (Math.abs(diff) >= 2) {

				var threshold = (diff > 0) ?
					30 :  // scrolling down
					200; // scrolling up

				$(document.body).toggleClass('ui-scroll-top', scrollPosition < threshold);

			}

			scrollPositionWas = scrollPosition;

		}


		// Listen for scroll events for updating the scroll-top status
		$(window).on('scroll', util.throttle(updateScrollTop, 67));

		// Update the scroll-top on document.ready
		$(document).ready(updateScrollTop);


		// ---------------------------------------------------------


		/**
		 * Close the login form.
		 */
		function closeLoginForm() {

			$element.removeClass('ui-show-login');

		}


		/**
		 * Toggle the visibility of the login form.
		 */
		function toggleLoginForm() {

			$element.toggleClass('ui-show-login');

		}


		// Open the login form when the login button is clicked
		$element.on('click', '.id-login-btn', function(event) {
			if (app.breakpoint.not('phone-l phone-s')) {
				event.preventDefault();
				toggleLoginForm();
			}
		});

		// Close the login form when clicking close
		$element.on('click', '.id-close-login-btn', closeLoginForm);

		// Close the login form when leaving tablet breakpoints
		app.breakpoint.when('tablet-l tablet-s', null, closeLoginForm);

		// ---------------------------------------------------------


		/**
		 * Hide the secondary nav
		 */
		function hideSecondaryNav() {

			$('.layout-header-nav__menu-secondary-container').hide();

		}


		/**
		 * Show the secondary nav
		 */
		function showSecondaryNav() {

			$('.layout-header-nav__menu-secondary-container').show();

		}


		// Show the secondary nav menu
		$element.on('mouseenter', '.layout-header-nav__menu li:eq(1)', function(event) {
			if (app.breakpoint.is('desktop')) {
				showSecondaryNav();
			}
		});

		// Hide the secondary nav menu
		$element.on('mouseleave', '.layout-header-nav__menu-secondary-container, .layout-header-nav__menu-container', function(event) {
			event.stopPropagation();
			hideSecondaryNav();
		});

		// Hide the secondary nav menu
		$element.on('mouseenter', '.layout-header-nav__menu li:not(:eq(1))', function(event) {
			event.stopPropagation();
			hideSecondaryNav();
		});

	};

}($, app, util));
